import { metaAI } from "neql"

export type AIModel = NonNullable<
    metaAI.GetAiModelsQueryResult["data"]
>["meta_ai_model"][number]

export type AIModelForApp = NonNullable<
    NonNullable<
        metaAI.GetAiModelForAppQueryResult["data"]
    >["meta_ai_model_by_pk"]
>

export type AITrainingTemplate = NonNullable<
    metaAI.GetAiTrainingTemplateQueryResult["data"]
>["meta_ai_training_template"][number]

export type AITrainingInstance =
    AITrainingTemplate["training_instances"][number]

export type AIDataset = NonNullable<
    metaAI.GetDatasetsQueryResult["data"]
>["meta_ai_dataset"][number]

export type AIDatasetWithMetrics = NonNullable<
    NonNullable<
        metaAI.GetDatasetWithMetricsQueryResult["data"]
    >["meta_ai_dataset_by_pk"]
>

export type AIMetric = NonNullable<AIDatasetWithMetrics["metrics"][number]>

export type AITrainingMetric = NonNullable<
    NonNullable<
        metaAI.GetAiTrainingInstanceQueryResult["data"]
    >["meta_ai_training_instance_by_pk"]
>["metrics"][number]

export type AIModelAssignment = AIModelForApp["apps"][number]

export type AIModelAssignmentEnum = metaAI.Meta_Ai_Assignment_Enum

export type AIModelDeploymentStatus = metaAI.Meta_Ai_Deployment_Status

export const noRefreshStates = [
    metaAI.Meta_Ai_Training_State_Enum.Finished,
    metaAI.Meta_Ai_Training_State_Enum.InternalError,
    metaAI.Meta_Ai_Training_State_Enum.Stopped
]

export const shouldStopRefreshingAIInstance = (
    trainingInstance: AITrainingInstance
) =>
    noRefreshStates.includes(trainingInstance.state) &&
    (trainingInstance.state !== metaAI.Meta_Ai_Training_State_Enum.Finished ||
        trainingInstance.output_model !== null)

export function getAIModelID(model: AIModelForApp): string {
    return model.id
}

export function getTotalPredictionCount(model: AIModelForApp): number {
    return model.apps.reduce(
        (accum, app) =>
            accum + (app.predictions_aggregate.aggregate?.count ?? 0),
        0
    )
}

export function hasActiveAssignment(model: AIModelForApp): boolean {
    return model.apps.some(assignment => assignment.active)
}

export function hasInactiveAssignment(model: AIModelForApp): boolean {
    return model.apps.some(assignment => !assignment.active)
}

export function getModelName(model: AIModel): string {
    return model.name
}

export function getAITemplateID(trainingTemplate: AITrainingTemplate): string {
    return trainingTemplate.id
}

export function getAIInstanceID(trainingInstance: AITrainingInstance): string {
    return trainingInstance.id
}

export function getAIModelAssignmentID(assignment: AIModelAssignment): string {
    return assignment.assigned
}
